module.exports = __webpack_public_path__ + "img/instaIcon.3ad478da.svg";